<template>
  <div class="tour-price" :class="{ 'tour-price--sale': isSale, 'tour-price--small': small }">
    <div class="tour-price__from">
      {{ fromText }}
    </div>
    <div class="tour-price__price">
      {{ formatPrice(price, lang, 'EUR') }}
    </div>
    <div class="tour-price__group">
      {{ groupText }}
    </div>
  </div>
</template>

<script>
import { formatCurrency } from "@/utils/utils";
import { formatPrice } from "@/utils/price";

export default {
  name: "TourPrice",
  props: {
    oldPrice: { type: String, default: "" },
    price: { type: String, default: "" },
    isGroupPricing: { type: Boolean, default: false },
    maxTravelers: { type: Number, default: 0 },
    currency: { type: Object, default: () => ({}) },
    small: { type: Boolean, default: false },
    translations: { type: Object, default: () => ({}) },
  },
  computed: {
    isSale() {
      return Number(this.oldPrice) > 0;
    },
    lang() {
      return this.$cookies.get("i18n_redirected") ?? 'en';
    },
    fromText() {
      if (this.isSale && this.oldPrice && !isNaN(Number(this.oldPrice))) {
        const prefix = this.translations?.textFrom?.text || '';
        return `${prefix} ${this.formatPrice(this.oldPrice, this.lang, 'EUR')}`.trim();
      }
      return this.translations?.textFrom?.text || '';
    },
    priceString() {
      if (!this.price || isNaN(Number(this.price))) return '';
      return this.formatPrice(this.price, this.lang, 'EUR');
    },
    groupText() {
      return this.isGroupPricing
        ? `${this.translations.textPerGroup.text} ${this.maxTravelers}`
        : this.translations.textPerPerson.text;
    },
  },
  methods: {
    formatPrice,
  },
};
</script>

<style lang="scss">
.tour-price {
  position: relative;
  flex-shrink: 0;
  text-align: right;

  &__price {
    font-size: 22px;
    font-weight: 600;
    color: #1e2843;
    text-align: right;
    white-space: nowrap;
    letter-spacing: -1.5px;
  }

  &__from {
    font-size: 12px;
    color: #565e72;
    white-space: nowrap;
    text-align: right;
  }

  &__group {
    font-size: 12px;
    font-weight: 500;
    color: #565e72;
    text-align: right;
    white-space: nowrap;

    &--sale {
      color: $orange;
    }
  }

  &--sale {

    .tour-price__price,
    .tour-price__group {
      color: $orange;
    }

    .tour-price__from {
      text-decoration: line-through;
    }
  }

  &--small {
    .tour-price__price {
      font-size: 18px;
    }
  }
}
</style>
